import languageBundle from '@kirschbaum-development/laravel-translations-loader!@kirschbaum-development/laravel-translations-loader';
import { createI18n } from 'vue-i18n'

console.log(languageBundle);

export default createI18n({
  legacy: false,
  locale: 'en',
  messages: languageBundle,
});
